import axiosHandler, { type SessionAwareRequestConfig } from './axios-handler';
import { academyApiUrl } from '@/lib/constants/api';
import { setAuthUserInStorage } from './auth/common/auth-storage';
import { isUserLoggedIn } from '@/helpers/local-storage';

export default async function getUser() {
  const options: SessionAwareRequestConfig = {
    method: 'GET',
    url: academyApiUrl('/v1/users'),
    withCredentials: true,
    // Profile fetch, called only after the probe already said `valid` — a 401 here must not
    // raise suspicion, or it'd loop (suspect -> probe valid -> still missing -> 401 -> ...).
    skipSessionCheck: true,
  };
  const response = await axiosHandler(options);
  return response;
}

/**
 * Fetches the full user and syncs to localStorage + dispatches userDataUpdated. Use after
 * OAuth/SSO login so all consumers have complete user data. Returns true only when fetched
 * AND stored — callers reloading on this must check it, or a failed write loops forever.
 */
export async function fetchAndSyncUser(): Promise<boolean> {
  try {
    const response = await getUser();
    if (response?.status === 200 && response && 'data' in response && response.data) {
      // Both halves matter: the write can fail (private mode/quota), and a stored but
      // email-less profile still reads as logged-out.
      return setAuthUserInStorage(response.data as Record<string, unknown>) && isUserLoggedIn();
    }
    return false;
  } catch {
    return false;
  }
}

